import axios from 'axios';
import { ensureCsrfToken } from '../../../lib/csrf';

const BASE = '/api/digital-risk/investment-planning-cycles/';
const config = { withCredentials: true };
export async function getCurrentPlanningCycle(){ return (await axios.get(`${BASE}current/`, config)).data; }
export async function getPlanningContext(ref){ return (await axios.get(`${BASE}${ref}/planning-context/`, config)).data; }
export async function listProjects(ref){ return (await axios.get(`${BASE}${ref}/projects/`, config)).data; }
export async function getProject(cycleRef, projectRef){ return (await axios.get(`${BASE}${cycleRef}/projects/${projectRef}/`, config)).data; }
export async function getScenarioContext(){ return (await axios.get('/api/digital-risk/investment-projects/scenario-context/', config)).data; }
export async function saveProject(cycleRef, payload, projectRef){
  const token=await ensureCsrfToken();
  const request={withCredentials:true,headers:{'X-CSRFToken':token}};
  const url=`${BASE}${cycleRef}/projects/${projectRef ? `${projectRef}/` : ''}`;
  return (projectRef ? await axios.patch(url,payload,request) : await axios.post(url,payload,request)).data;
}
export async function handoffPlanningCycle(payload){
  const token=await ensureCsrfToken();
  return (await axios.post(`${BASE}handoff/`,payload,{withCredentials:true,headers:{'X-CSRFToken':token}})).data;
}
